import "./index.css";
import { jsxs as e, Fragment as t, jsx as n } from "react/jsx-runtime";
import { Icon as r } from "@design-system/icon";
import { Typography as o } from "@design-system/typography";
import a from "classnames";
import i, { forwardRef as c } from "react";
import u from "react-dom";
function s(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (n) {
    var r = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, r.get ? r : {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  }), t;
}
var l = {
    exports: {}
  },
  f = {
    exports: {}
  },
  p = {},
  d = "function" == typeof Symbol && Symbol.for,
  v = d ? Symbol.for("react.element") : 60103,
  y = d ? Symbol.for("react.portal") : 60106,
  b = d ? Symbol.for("react.fragment") : 60107,
  m = d ? Symbol.for("react.strict_mode") : 60108,
  h = d ? Symbol.for("react.profiler") : 60114,
  g = d ? Symbol.for("react.provider") : 60109,
  O = d ? Symbol.for("react.context") : 60110,
  w = d ? Symbol.for("react.async_mode") : 60111,
  E = d ? Symbol.for("react.concurrent_mode") : 60111,
  S = d ? Symbol.for("react.forward_ref") : 60112,
  T = d ? Symbol.for("react.suspense") : 60113,
  P = d ? Symbol.for("react.suspense_list") : 60120,
  k = d ? Symbol.for("react.memo") : 60115,
  D = d ? Symbol.for("react.lazy") : 60116,
  N = d ? Symbol.for("react.block") : 60121,
  j = d ? Symbol.for("react.fundamental") : 60117,
  F = d ? Symbol.for("react.responder") : 60118,
  C = d ? Symbol.for("react.scope") : 60119;
function x(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case v:
        switch (e = e.type) {
          case w:
          case E:
          case b:
          case h:
          case m:
          case T:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case O:
              case S:
              case D:
              case k:
              case g:
                return e;
              default:
                return t;
            }
        }
      case y:
        return t;
    }
  }
}
function R(e) {
  return x(e) === E;
}
p.AsyncMode = w, p.ConcurrentMode = E, p.ContextConsumer = O, p.ContextProvider = g, p.Element = v, p.ForwardRef = S, p.Fragment = b, p.Lazy = D, p.Memo = k, p.Portal = y, p.Profiler = h, p.StrictMode = m, p.Suspense = T, p.isAsyncMode = function (e) {
  return R(e) || x(e) === w;
}, p.isConcurrentMode = R, p.isContextConsumer = function (e) {
  return x(e) === O;
}, p.isContextProvider = function (e) {
  return x(e) === g;
}, p.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === v;
}, p.isForwardRef = function (e) {
  return x(e) === S;
}, p.isFragment = function (e) {
  return x(e) === b;
}, p.isLazy = function (e) {
  return x(e) === D;
}, p.isMemo = function (e) {
  return x(e) === k;
}, p.isPortal = function (e) {
  return x(e) === y;
}, p.isProfiler = function (e) {
  return x(e) === h;
}, p.isStrictMode = function (e) {
  return x(e) === m;
}, p.isSuspense = function (e) {
  return x(e) === T;
}, p.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === b || e === E || e === h || e === m || e === T || e === P || "object" == typeof e && null !== e && (e.$$typeof === D || e.$$typeof === k || e.$$typeof === g || e.$$typeof === O || e.$$typeof === S || e.$$typeof === j || e.$$typeof === F || e.$$typeof === C || e.$$typeof === N);
}, p.typeOf = x;
var _ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    a = e ? Symbol.for("react.profiler") : 60114,
    i = e ? Symbol.for("react.provider") : 60109,
    c = e ? Symbol.for("react.context") : 60110,
    u = e ? Symbol.for("react.async_mode") : 60111,
    s = e ? Symbol.for("react.concurrent_mode") : 60111,
    l = e ? Symbol.for("react.forward_ref") : 60112,
    f = e ? Symbol.for("react.suspense") : 60113,
    p = e ? Symbol.for("react.suspense_list") : 60120,
    d = e ? Symbol.for("react.memo") : 60115,
    v = e ? Symbol.for("react.lazy") : 60116,
    y = e ? Symbol.for("react.block") : 60121,
    b = e ? Symbol.for("react.fundamental") : 60117,
    m = e ? Symbol.for("react.responder") : 60118,
    h = e ? Symbol.for("react.scope") : 60119;
  function g(e) {
    if ("object" == typeof e && null !== e) {
      var p = e.$$typeof;
      switch (p) {
        case t:
          var y = e.type;
          switch (y) {
            case u:
            case s:
            case r:
            case a:
            case o:
            case f:
              return y;
            default:
              var b = y && y.$$typeof;
              switch (b) {
                case c:
                case l:
                case v:
                case d:
                case i:
                  return b;
                default:
                  return p;
              }
          }
        case n:
          return p;
      }
    }
  }
  var O = u,
    w = s,
    E = c,
    S = i,
    T = t,
    P = l,
    k = r,
    D = v,
    N = d,
    j = n,
    F = a,
    C = o,
    x = f,
    R = !1;
  function I(e) {
    return g(e) === s;
  }
  _.AsyncMode = O, _.ConcurrentMode = w, _.ContextConsumer = E, _.ContextProvider = S, _.Element = T, _.ForwardRef = P, _.Fragment = k, _.Lazy = D, _.Memo = N, _.Portal = j, _.Profiler = F, _.StrictMode = C, _.Suspense = x, _.isAsyncMode = function (e) {
    return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(e) || g(e) === u;
  }, _.isConcurrentMode = I, _.isContextConsumer = function (e) {
    return g(e) === c;
  }, _.isContextProvider = function (e) {
    return g(e) === i;
  }, _.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, _.isForwardRef = function (e) {
    return g(e) === l;
  }, _.isFragment = function (e) {
    return g(e) === r;
  }, _.isLazy = function (e) {
    return g(e) === v;
  }, _.isMemo = function (e) {
    return g(e) === d;
  }, _.isPortal = function (e) {
    return g(e) === n;
  }, _.isProfiler = function (e) {
    return g(e) === a;
  }, _.isStrictMode = function (e) {
    return g(e) === o;
  }, _.isSuspense = function (e) {
    return g(e) === f;
  }, _.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === s || e === a || e === o || e === f || e === p || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === d || e.$$typeof === i || e.$$typeof === c || e.$$typeof === l || e.$$typeof === b || e.$$typeof === m || e.$$typeof === h || e.$$typeof === y);
  }, _.typeOf = g;
}(), "production" === process.env.NODE_ENV ? f.exports = p : f.exports = _
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/;
var I = Object.getOwnPropertySymbols,
  $ = Object.prototype.hasOwnProperty,
  A = Object.prototype.propertyIsEnumerable;
function L(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
var M = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }
      var r = Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      });
      if ("0123456789" !== r.join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = L(e), a = 1; a < arguments.length; a++) {
      for (var i in n = Object(arguments[a])) {
        $.call(n, i) && (o[i] = n[i]);
      }
      if (I) {
        r = I(n);
        for (var c = 0; c < r.length; c++) {
          A.call(n, r[c]) && (o[r[c]] = n[r[c]]);
        }
      }
    }
    return o;
  },
  G = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  V = Function.call.bind(Object.prototype.hasOwnProperty),
  B = function B() {};
if ("production" !== process.env.NODE_ENV) {
  var U = G,
    q = {},
    z = V;
  B = function B(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);
    try {
      throw new Error(t);
    } catch (e) {}
  };
}
function W(e, t, n, r, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (z(e, a)) {
      var i;
      try {
        if ("function" != typeof e[a]) {
          var c = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
          throw c.name = "Invariant Violation", c;
        }
        i = e[a](t, a, r, n, null, U);
      } catch (e) {
        i = e;
      }
      if (!i || i instanceof Error || B((r || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in q)) {
        q[i.message] = !0;
        var u = o ? o() : "";
        B("Failed " + n + " type: " + i.message + (null != u ? u : ""));
      }
    }
  }
}
W.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (q = {});
};
var K = W,
  Y = f.exports,
  J = M,
  H = G,
  X = V,
  Q = K,
  Z = function Z() {};
function ee() {
  return null;
}
"production" !== process.env.NODE_ENV && (Z = function Z(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);
  try {
    throw new Error(t);
  } catch (e) {}
});
function te() {}
function ne() {}
ne.resetWarningCache = te;
if ("production" !== process.env.NODE_ENV) {
  var re = f.exports;
  l.exports = function (e, t) {
    var n = "function" == typeof Symbol && Symbol.iterator,
      r = "<<anonymous>>",
      o = {
        array: u("array"),
        bigint: u("bigint"),
        bool: u("boolean"),
        func: u("function"),
        number: u("number"),
        object: u("object"),
        string: u("string"),
        symbol: u("symbol"),
        any: c(ee),
        arrayOf: function arrayOf(e) {
          return c(function (t, n, r, o, a) {
            if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var c = t[n];
            if (!Array.isArray(c)) return new i("Invalid " + o + " `" + a + "` of type `" + f(c) + "` supplied to `" + r + "`, expected an array.");
            for (var u = 0; u < c.length; u++) {
              var s = e(c, u, r, o, a + "[" + u + "]", H);
              if (s instanceof Error) return s;
            }
            return null;
          });
        },
        element: c(function (t, n, r, o, a) {
          var c = t[n];
          return e(c) ? null : new i("Invalid " + o + " `" + a + "` of type `" + f(c) + "` supplied to `" + r + "`, expected a single ReactElement.");
        }),
        elementType: c(function (e, t, n, r, o) {
          var a = e[t];
          return Y.isValidElementType(a) ? null : new i("Invalid " + r + " `" + o + "` of type `" + f(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(e) {
          return c(function (t, n, o, a, c) {
            if (!(t[n] instanceof e)) {
              var u = e.name || r;
              return new i("Invalid " + a + " `" + c + "` of type `" + ((s = t[n]).constructor && s.constructor.name ? s.constructor.name : r) + "` supplied to `" + o + "`, expected instance of `" + u + "`.");
            }
            var s;
            return null;
          });
        },
        node: c(function (e, t, n, r, o) {
          return l(e[t]) ? null : new i("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(e) {
          return c(function (t, n, r, o, a) {
            if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var c = t[n],
              u = f(c);
            if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + r + "`, expected an object.");
            for (var s in c) {
              if (X(c, s)) {
                var l = e(c, s, r, o, a + "." + s, H);
                if (l instanceof Error) return l;
              }
            }
            return null;
          });
        },
        oneOf: function oneOf(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Z(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), ee;
          function t(t, n, r, o, c) {
            for (var u = t[n], s = 0; s < e.length; s++) {
              if (a(u, e[s])) return null;
            }
            var l = JSON.stringify(e, function (e, t) {
              return "symbol" === p(t) ? String(t) : t;
            });
            return new i("Invalid " + o + " `" + c + "` of value `" + String(u) + "` supplied to `" + r + "`, expected one of " + l + ".");
          }
          return c(t);
        },
        oneOfType: function oneOfType(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && Z("Invalid argument supplied to oneOfType, expected an instance of array."), ee;
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            if ("function" != typeof n) return Z("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + d(n) + " at index " + t + "."), ee;
          }
          return c(function (t, n, r, o, a) {
            for (var c = [], u = 0; u < e.length; u++) {
              var s = (0, e[u])(t, n, r, o, a, H);
              if (null == s) return null;
              s.data && X(s.data, "expectedType") && c.push(s.data.expectedType);
            }
            return new i("Invalid " + o + " `" + a + "` supplied to `" + r + "`" + (c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(e) {
          return c(function (t, n, r, o, a) {
            var c = t[n],
              u = f(c);
            if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");
            for (var l in e) {
              var d = e[l];
              if ("function" != typeof d) return s(r, o, a, l, p(d));
              var v = d(c, l, r, o, a + "." + l, H);
              if (v) return v;
            }
            return null;
          });
        },
        exact: function exact(e) {
          return c(function (t, n, r, o, a) {
            var c = t[n],
              u = f(c);
            if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + r + "`, expected `object`.");
            var l = J({}, t[n], e);
            for (var d in l) {
              var v = e[d];
              if (X(e, d) && "function" != typeof v) return s(r, o, a, d, p(v));
              if (!v) return new i("Invalid " + o + " `" + a + "` key `" + d + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var y = v(c, d, r, o, a + "." + d, H);
              if (y) return y;
            }
            return null;
          });
        }
      };
    function a(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }
    function i(e, t) {
      this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
    }
    function c(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
        o = 0;
      function a(a, c, u, s, l, f, p) {
        if (s = s || r, f = f || u, p !== H) {
          if (t) {
            var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw d.name = "Invariant Violation", d;
          }
          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var v = s + ":" + u;
            !n[v] && o < 3 && (Z("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[v] = !0, o++);
          }
        }
        return null == c[u] ? a ? null === c[u] ? new i("The " + l + " `" + f + "` is marked as required in `" + s + "`, but its value is `null`.") : new i("The " + l + " `" + f + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(c, u, s, l, f);
      }
      var c = a.bind(null, !1);
      return c.isRequired = a.bind(null, !0), c;
    }
    function u(e) {
      return c(function (t, n, r, o, a, c) {
        var u = t[n];
        return f(u) !== e ? new i("Invalid " + o + " `" + a + "` of type `" + p(u) + "` supplied to `" + r + "`, expected `" + e + "`.", {
          expectedType: e
        }) : null;
      });
    }
    function s(e, t, n, r, o) {
      return new i((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
    }
    function l(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !t;
        case "object":
          if (Array.isArray(t)) return t.every(l);
          if (null === t || e(t)) return !0;
          var r = function (e) {
            var t = e && (n && e[n] || e["@@iterator"]);
            if ("function" == typeof t) return t;
          }(t);
          if (!r) return !1;
          var o,
            a = r.call(t);
          if (r !== t.entries) {
            for (; !(o = a.next()).done;) {
              if (!l(o.value)) return !1;
            }
          } else for (; !(o = a.next()).done;) {
            var i = o.value;
            if (i && !l(i[1])) return !1;
          }
          return !0;
        default:
          return !1;
      }
    }
    function f(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }
    function p(e) {
      if (null == e) return "" + e;
      var t = f(e);
      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }
      return t;
    }
    function d(e) {
      var t = p(e);
      switch (t) {
        case "array":
        case "object":
          return "an " + t;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;
        default:
          return t;
      }
    }
    return i.prototype = Error.prototype, o.checkPropTypes = Q, o.resetWarningCache = Q.resetWarningCache, o.PropTypes = o, o;
  }(re.isElement, !0);
} else l.exports = function () {
  function e(e, t, n, r, o, a) {
    if ("SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED" !== a) {
      var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i.name = "Invariant Violation", i;
    }
  }
  function t() {
    return e;
  }
  e.isRequired = e;
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: ne,
    resetWarningCache: te
  };
  return n.PropTypes = n, n;
}();
/*!
* tabbable 6.1.1
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var oe = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"],
  ae = oe.join(","),
  ie = "undefined" == typeof Element,
  ce = ie ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  ue = !ie && Element.prototype.getRootNode ? function (e) {
    var t;
    return null == e || null === (t = e.getRootNode) || void 0 === t ? void 0 : t.call(e);
  } : function (e) {
    return null == e ? void 0 : e.ownerDocument;
  },
  se = function e(t, n) {
    var r;
    void 0 === n && (n = !0);
    var o = null == t || null === (r = t.getAttribute) || void 0 === r ? void 0 : r.call(t, "inert");
    return "" === o || "true" === o || n && t && e(t.parentNode);
  },
  le = function le(e, t, n) {
    if (se(e)) return [];
    var r = Array.prototype.slice.apply(e.querySelectorAll(ae));
    return t && ce.call(e, ae) && r.unshift(e), r = r.filter(n);
  },
  fe = function e(t, n, r) {
    for (var o = [], a = Array.from(t); a.length;) {
      var i = a.shift();
      if (!se(i, !1)) if ("SLOT" === i.tagName) {
        var c = i.assignedElements(),
          u = e(c.length ? c : i.children, !0, r);
        r.flatten ? o.push.apply(o, u) : o.push({
          scopeParent: i,
          candidates: u
        });
      } else {
        ce.call(i, ae) && r.filter(i) && (n || !t.includes(i)) && o.push(i);
        var s = i.shadowRoot || "function" == typeof r.getShadowRoot && r.getShadowRoot(i),
          l = !se(s, !1) && (!r.shadowRootFilter || r.shadowRootFilter(i));
        if (s && l) {
          var f = e(!0 === s ? i.children : s.children, !0, r);
          r.flatten ? o.push.apply(o, f) : o.push({
            scopeParent: i,
            candidates: f
          });
        } else a.unshift.apply(a, i.children);
      }
    }
    return o;
  },
  pe = function pe(e, t) {
    return e.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || function (e) {
      var t,
        n = null == e || null === (t = e.getAttribute) || void 0 === t ? void 0 : t.call(e, "contenteditable");
      return "" === n || "true" === n;
    }(e)) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
  },
  de = function de(e, t) {
    return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
  },
  ve = function ve(e) {
    return "INPUT" === e.tagName;
  },
  ye = function ye(e) {
    return function (e) {
      return ve(e) && "radio" === e.type;
    }(e) && !function (e) {
      if (!e.name) return !0;
      var t,
        n = e.form || ue(e),
        r = function r(e) {
          return n.querySelectorAll('input[type="radio"][name="' + e + '"]');
        };
      if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = r(window.CSS.escape(e.name));else try {
        t = r(e.name);
      } catch (e) {
        return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
      }
      var o = function (e, t) {
        for (var n = 0; n < e.length; n++) {
          if (e[n].checked && e[n].form === t) return e[n];
        }
      }(t, e.form);
      return !o || o === e;
    }(e);
  },
  be = function be(e) {
    var t = e.getBoundingClientRect(),
      n = t.width,
      r = t.height;
    return 0 === n && 0 === r;
  },
  me = function me(e, t) {
    var n = t.displayCheck,
      r = t.getShadowRoot;
    if ("hidden" === getComputedStyle(e).visibility) return !0;
    var o = ce.call(e, "details>summary:first-of-type") ? e.parentElement : e;
    if (ce.call(o, "details:not([open]) *")) return !0;
    if (n && "full" !== n && "legacy-full" !== n) {
      if ("non-zero-area" === n) return be(e);
    } else {
      if ("function" == typeof r) {
        for (var a = e; e;) {
          var i = e.parentElement,
            c = ue(e);
          if (i && !i.shadowRoot && !0 === r(i)) return be(e);
          e = e.assignedSlot ? e.assignedSlot : i || c === e.ownerDocument ? i : c.host;
        }
        e = a;
      }
      if (function (e) {
        var t,
          n,
          r,
          o,
          a = e && ue(e),
          i = null === (t = a) || void 0 === t ? void 0 : t.host,
          c = !1;
        if (a && a !== e) for (c = !!(null !== (n = i) && void 0 !== n && null !== (r = n.ownerDocument) && void 0 !== r && r.contains(i) || null != e && null !== (o = e.ownerDocument) && void 0 !== o && o.contains(e)); !c && i;) {
          var u, s, l;
          c = !(null === (s = i = null === (u = a = ue(i)) || void 0 === u ? void 0 : u.host) || void 0 === s || null === (l = s.ownerDocument) || void 0 === l || !l.contains(i));
        }
        return c;
      }(e)) return !e.getClientRects().length;
      if ("legacy-full" !== n) return !0;
    }
    return !1;
  },
  he = function he(e, t) {
    return !(t.disabled || se(t) || function (e) {
      return ve(e) && "hidden" === e.type;
    }(t) || me(t, e) || function (e) {
      return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some(function (e) {
        return "SUMMARY" === e.tagName;
      });
    }(t) || function (e) {
      if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
        if ("FIELDSET" === t.tagName && t.disabled) {
          for (var n = 0; n < t.children.length; n++) {
            var r = t.children.item(n);
            if ("LEGEND" === r.tagName) return !!ce.call(t, "fieldset[disabled] *") || !r.contains(e);
          }
          return !0;
        }
        t = t.parentElement;
      }
      return !1;
    }(t));
  },
  ge = function ge(e, t) {
    return !(ye(t) || pe(t) < 0 || !he(e, t));
  },
  Oe = function Oe(e) {
    var t = parseInt(e.getAttribute("tabindex"), 10);
    return !!(isNaN(t) || t >= 0);
  },
  we = function e(t) {
    var n = [],
      r = [];
    return t.forEach(function (t, o) {
      var a = !!t.scopeParent,
        i = a ? t.scopeParent : t,
        c = pe(i, a),
        u = a ? e(t.candidates) : i;
      0 === c ? a ? n.push.apply(n, u) : n.push(i) : r.push({
        documentOrder: o,
        tabIndex: c,
        item: t,
        isScope: a,
        content: u
      });
    }), r.sort(de).reduce(function (e, t) {
      return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
    }, []).concat(n);
  },
  Ee = function Ee(e, t) {
    var n;
    return n = (t = t || {}).getShadowRoot ? fe([e], t.includeContainer, {
      filter: ge.bind(null, t),
      flatten: !1,
      getShadowRoot: t.getShadowRoot,
      shadowRootFilter: Oe
    }) : le(e, t.includeContainer, ge.bind(null, t)), we(n);
  },
  Se = function Se(e, t) {
    return (t = t || {}).getShadowRoot ? fe([e], t.includeContainer, {
      filter: he.bind(null, t),
      flatten: !0,
      getShadowRoot: t.getShadowRoot
    }) : le(e, t.includeContainer, he.bind(null, t));
  },
  Te = function Te(e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== ce.call(e, ae) && ge(t, e);
  },
  Pe = oe.concat("iframe").join(","),
  ke = function ke(e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== ce.call(e, Pe) && he(t, e);
  },
  De = Object.freeze({
    __proto__: null,
    focusable: Se,
    isFocusable: ke,
    isTabbable: Te,
    tabbable: Ee
  });
/*!
* focus-trap 7.4.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Ne(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ne(Object(n), !0).forEach(function (t) {
      Fe(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ne(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Fe(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ce = function Ce(e, t) {
    if (e.length > 0) {
      var n = e[e.length - 1];
      n !== t && n.pause();
    }
    var r = e.indexOf(t);
    -1 === r || e.splice(r, 1), e.push(t);
  },
  xe = function xe(e, t) {
    var n = e.indexOf(t);
    -1 !== n && e.splice(n, 1), e.length > 0 && e[e.length - 1].unpause();
  },
  Re = function Re(e) {
    return "Tab" === e.key || 9 === e.keyCode;
  },
  _e = function _e(e) {
    return Re(e) && !e.shiftKey;
  },
  Ie = function Ie(e) {
    return Re(e) && e.shiftKey;
  },
  $e = function $e(e) {
    return setTimeout(e, 0);
  },
  Ae = function Ae(e, t) {
    var n = -1;
    return e.every(function (e, r) {
      return !t(e) || (n = r, !1);
    }), n;
  },
  Le = function Le(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
      n[r - 1] = arguments[r];
    }
    return "function" == typeof e ? e.apply(void 0, n) : e;
  },
  Me = function Me(e) {
    return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
  },
  Ge = [],
  Ve = Object.freeze({
    __proto__: null,
    createFocusTrap: function createFocusTrap(e, t) {
      var n,
        r = (null == t ? void 0 : t.document) || document,
        o = (null == t ? void 0 : t.trapStack) || Ge,
        a = je({
          returnFocusOnDeactivate: !0,
          escapeDeactivates: !0,
          delayInitialFocus: !0,
          isKeyForward: _e,
          isKeyBackward: Ie
        }, t),
        i = {
          containers: [],
          containerGroups: [],
          tabbableGroups: [],
          nodeFocusedBeforeActivation: null,
          mostRecentlyFocusedNode: null,
          active: !1,
          paused: !1,
          delayInitialFocusTimer: void 0
        },
        c = function c(e, t, n) {
          return e && void 0 !== e[t] ? e[t] : a[n || t];
        },
        u = function u(e) {
          return i.containerGroups.findIndex(function (t) {
            var n = t.container,
              r = t.tabbableNodes;
            return n.contains(e) || r.find(function (t) {
              return t === e;
            });
          });
        },
        s = function s(e) {
          var t = a[e];
          if ("function" == typeof t) {
            for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
              o[i - 1] = arguments[i];
            }
            t = t.apply(void 0, o);
          }
          if (!0 === t && (t = void 0), !t) {
            if (void 0 === t || !1 === t) return t;
            throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
          }
          var c = t;
          if ("string" == typeof t && !(c = r.querySelector(t))) throw new Error("`".concat(e, "` as selector refers to no known node"));
          return c;
        },
        l = function l() {
          var e = s("initialFocus");
          if (!1 === e) return !1;
          if (void 0 === e) if (u(r.activeElement) >= 0) e = r.activeElement;else {
            var t = i.tabbableGroups[0];
            e = t && t.firstTabbableNode || s("fallbackFocus");
          }
          if (!e) throw new Error("Your focus-trap needs to have at least one focusable element");
          return e;
        },
        f = function f() {
          if (i.containerGroups = i.containers.map(function (e) {
            var t = Ee(e, a.tabbableOptions),
              n = Se(e, a.tabbableOptions);
            return {
              container: e,
              tabbableNodes: t,
              focusableNodes: n,
              firstTabbableNode: t.length > 0 ? t[0] : null,
              lastTabbableNode: t.length > 0 ? t[t.length - 1] : null,
              nextTabbableNode: function nextTabbableNode(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                  r = n.findIndex(function (t) {
                    return t === e;
                  });
                if (!(r < 0)) return t ? n.slice(r + 1).find(function (e) {
                  return Te(e, a.tabbableOptions);
                }) : n.slice(0, r).reverse().find(function (e) {
                  return Te(e, a.tabbableOptions);
                });
              }
            };
          }), i.tabbableGroups = i.containerGroups.filter(function (e) {
            return e.tabbableNodes.length > 0;
          }), i.tabbableGroups.length <= 0 && !s("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        },
        p = function e(t) {
          !1 !== t && t !== r.activeElement && (t && t.focus ? (t.focus({
            preventScroll: !!a.preventScroll
          }), i.mostRecentlyFocusedNode = t, function (e) {
            return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
          }(t) && t.select()) : e(l()));
        },
        d = function d(e) {
          var t = s("setReturnFocus", e);
          return t || !1 !== t && e;
        },
        v = function v(e) {
          var t = Me(e);
          u(t) >= 0 || (Le(a.clickOutsideDeactivates, e) ? n.deactivate({
            returnFocus: a.returnFocusOnDeactivate
          }) : Le(a.allowOutsideClick, e) || e.preventDefault());
        },
        y = function y(e) {
          var t = Me(e),
            n = u(t) >= 0;
          n || t instanceof Document ? n && (i.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(), p(i.mostRecentlyFocusedNode || l()));
        },
        b = function b(e) {
          if (function (e) {
            return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
          }(e) && !1 !== Le(a.escapeDeactivates, e)) return e.preventDefault(), void n.deactivate();
          (a.isKeyForward(e) || a.isKeyBackward(e)) && function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = Me(e);
            f();
            var r = null;
            if (i.tabbableGroups.length > 0) {
              var o = u(n),
                c = o >= 0 ? i.containerGroups[o] : void 0;
              if (o < 0) r = t ? i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : i.tabbableGroups[0].firstTabbableNode;else if (t) {
                var l = Ae(i.tabbableGroups, function (e) {
                  var t = e.firstTabbableNode;
                  return n === t;
                });
                if (l < 0 && (c.container === n || ke(n, a.tabbableOptions) && !Te(n, a.tabbableOptions) && !c.nextTabbableNode(n, !1)) && (l = o), l >= 0) {
                  var d = 0 === l ? i.tabbableGroups.length - 1 : l - 1;
                  r = i.tabbableGroups[d].lastTabbableNode;
                } else Re(e) || (r = c.nextTabbableNode(n, !1));
              } else {
                var v = Ae(i.tabbableGroups, function (e) {
                  var t = e.lastTabbableNode;
                  return n === t;
                });
                if (v < 0 && (c.container === n || ke(n, a.tabbableOptions) && !Te(n, a.tabbableOptions) && !c.nextTabbableNode(n)) && (v = o), v >= 0) {
                  var y = v === i.tabbableGroups.length - 1 ? 0 : v + 1;
                  r = i.tabbableGroups[y].firstTabbableNode;
                } else Re(e) || (r = c.nextTabbableNode(n));
              }
            } else r = s("fallbackFocus");
            r && (Re(e) && e.preventDefault(), p(r));
          }(e, a.isKeyBackward(e));
        },
        m = function m(e) {
          var t = Me(e);
          u(t) >= 0 || Le(a.clickOutsideDeactivates, e) || Le(a.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
        },
        h = function h() {
          if (i.active) return Ce(o, n), i.delayInitialFocusTimer = a.delayInitialFocus ? $e(function () {
            p(l());
          }) : p(l()), r.addEventListener("focusin", y, !0), r.addEventListener("mousedown", v, {
            capture: !0,
            passive: !1
          }), r.addEventListener("touchstart", v, {
            capture: !0,
            passive: !1
          }), r.addEventListener("click", m, {
            capture: !0,
            passive: !1
          }), r.addEventListener("keydown", b, {
            capture: !0,
            passive: !1
          }), n;
        },
        g = function g() {
          if (i.active) return r.removeEventListener("focusin", y, !0), r.removeEventListener("mousedown", v, !0), r.removeEventListener("touchstart", v, !0), r.removeEventListener("click", m, !0), r.removeEventListener("keydown", b, !0), n;
        };
      return (n = {
        get active() {
          return i.active;
        },
        get paused() {
          return i.paused;
        },
        activate: function activate(e) {
          if (i.active) return this;
          var t = c(e, "onActivate"),
            n = c(e, "onPostActivate"),
            o = c(e, "checkCanFocusTrap");
          o || f(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = r.activeElement, null == t || t();
          var a = function a() {
            o && f(), h(), null == n || n();
          };
          return o ? (o(i.containers.concat()).then(a, a), this) : (a(), this);
        },
        deactivate: function deactivate(e) {
          if (!i.active) return this;
          var t = je({
            onDeactivate: a.onDeactivate,
            onPostDeactivate: a.onPostDeactivate,
            checkCanReturnFocus: a.checkCanReturnFocus
          }, e);
          clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, g(), i.active = !1, i.paused = !1, xe(o, n);
          var r = c(t, "onDeactivate"),
            u = c(t, "onPostDeactivate"),
            s = c(t, "checkCanReturnFocus"),
            l = c(t, "returnFocus", "returnFocusOnDeactivate");
          null == r || r();
          var f = function f() {
            $e(function () {
              l && p(d(i.nodeFocusedBeforeActivation)), null == u || u();
            });
          };
          return l && s ? (s(d(i.nodeFocusedBeforeActivation)).then(f, f), this) : (f(), this);
        },
        pause: function pause(e) {
          if (i.paused || !i.active) return this;
          var t = c(e, "onPause"),
            n = c(e, "onPostPause");
          return i.paused = !0, null == t || t(), g(), null == n || n(), this;
        },
        unpause: function unpause(e) {
          if (!i.paused || !i.active) return this;
          var t = c(e, "onUnpause"),
            n = c(e, "onPostUnpause");
          return i.paused = !1, null == t || t(), f(), h(), null == n || n(), this;
        },
        updateContainerElements: function updateContainerElements(e) {
          var t = [].concat(e).filter(Boolean);
          return i.containers = t.map(function (e) {
            return "string" == typeof e ? r.querySelector(e) : e;
          }), i.active && f(), this;
        }
      }).updateContainerElements(e), n;
    }
  }),
  Be = s(Ve),
  Ue = s(De);
function qe(e) {
  return qe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qe(e);
}
function ze(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Xe(r.key), r);
  }
}
function We(e, t) {
  return We = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, We(e, t);
}
function Ke(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = He(e);
    if (t) {
      var o = He(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return Ye(this, n);
  };
}
function Ye(e, t) {
  if (t && ("object" === qe(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return Je(e);
}
function Je(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function He(e) {
  return He = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, He(e);
}
function Xe(e) {
  var t = function (e, t) {
    if ("object" !== qe(e) || null === e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var r = n.call(e, t || "default");
      if ("object" !== qe(r)) return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === qe(t) ? t : String(t);
}
var Qe = i,
  Ze = l.exports,
  et = Be.createFocusTrap,
  tt = Ue.isFocusable,
  nt = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && We(e, t);
    }(a, Qe.Component);
    var t,
      n,
      r,
      o = Ke(a);
    function a(e) {
      var t, n, r, i;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, a), t = o.call(this, e), n = Je(t), i = function i(e) {
        var t,
          n = null !== (t = this.internalOptions[e]) && void 0 !== t ? t : this.originalOptions[e];
        if ("function" == typeof n) {
          for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
            o[a - 1] = arguments[a];
          }
          n = n.apply(void 0, o);
        }
        if (!0 === n && (n = void 0), !n) {
          if (void 0 === n || !1 === n) return n;
          throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
        }
        var i,
          c = n;
        if ("string" == typeof n && !(c = null === (i = this.getDocument()) || void 0 === i ? void 0 : i.querySelector(n))) throw new Error("`".concat(e, "` as selector refers to no known node"));
        return c;
      }, (r = Xe(r = "getNodeForOption")) in n ? Object.defineProperty(n, r, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = i, t.handleDeactivate = t.handleDeactivate.bind(Je(t)), t.handlePostDeactivate = t.handlePostDeactivate.bind(Je(t)), t.handleClickOutsideDeactivates = t.handleClickOutsideDeactivates.bind(Je(t)), t.internalOptions = {
        returnFocusOnDeactivate: !1,
        checkCanReturnFocus: null,
        onDeactivate: t.handleDeactivate,
        onPostDeactivate: t.handlePostDeactivate,
        clickOutsideDeactivates: t.handleClickOutsideDeactivates
      }, t.originalOptions = {
        returnFocusOnDeactivate: !0,
        onDeactivate: null,
        onPostDeactivate: null,
        checkCanReturnFocus: null,
        clickOutsideDeactivates: !1
      };
      var c = e.focusTrapOptions;
      for (var u in c) {
        Object.prototype.hasOwnProperty.call(c, u) && ("returnFocusOnDeactivate" !== u && "onDeactivate" !== u && "onPostDeactivate" !== u && "checkCanReturnFocus" !== u && "clickOutsideDeactivates" !== u ? t.internalOptions[u] = c[u] : t.originalOptions[u] = c[u]);
      }
      return t.outsideClick = null, t.focusTrapElements = e.containerElements || [], t.updatePreviousElement(), t;
    }
    return t = a, (n = [{
      key: "getDocument",
      value: function value() {
        return this.props.focusTrapOptions.document || ("undefined" != typeof document ? document : void 0);
      }
    }, {
      key: "getReturnFocusNode",
      value: function value() {
        var e = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
        return e || !1 !== e && this.previouslyFocusedElement;
      }
    }, {
      key: "updatePreviousElement",
      value: function value() {
        var e = this.getDocument();
        e && (this.previouslyFocusedElement = e.activeElement);
      }
    }, {
      key: "deactivateTrap",
      value: function value() {
        this.focusTrap && this.focusTrap.active && this.focusTrap.deactivate({
          returnFocus: !1,
          checkCanReturnFocus: null,
          onDeactivate: this.originalOptions.onDeactivate
        });
      }
    }, {
      key: "handleClickOutsideDeactivates",
      value: function value(e) {
        var t = "function" == typeof this.originalOptions.clickOutsideDeactivates ? this.originalOptions.clickOutsideDeactivates.call(null, e) : this.originalOptions.clickOutsideDeactivates;
        return t && (this.outsideClick = {
          target: e.target,
          allowDeactivation: t
        }), t;
      }
    }, {
      key: "handleDeactivate",
      value: function value() {
        this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
      }
    }, {
      key: "handlePostDeactivate",
      value: function value() {
        var e = this,
          t = function t() {
            var t = e.getReturnFocusNode(),
              n = !(!e.originalOptions.returnFocusOnDeactivate || null == t || !t.focus || e.outsideClick && (!e.outsideClick.allowDeactivation || tt(e.outsideClick.target, e.internalOptions.tabbableOptions))),
              r = e.internalOptions.preventScroll,
              o = void 0 !== r && r;
            n && t.focus({
              preventScroll: o
            }), e.originalOptions.onPostDeactivate && e.originalOptions.onPostDeactivate.call(null), e.outsideClick = null;
          };
        this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(t, t) : t();
      }
    }, {
      key: "setupFocusTrap",
      value: function value() {
        this.focusTrap ? this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause()) : this.focusTrapElements.some(Boolean) && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.props.active && this.setupFocusTrap();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        if (this.focusTrap) {
          e.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
          var t = !e.active && this.props.active,
            n = e.active && !this.props.active,
            r = !e.paused && this.props.paused,
            o = e.paused && !this.props.paused;
          if (t && (this.updatePreviousElement(), this.focusTrap.activate()), n) return void this.deactivateTrap();
          r && this.focusTrap.pause(), o && this.focusTrap.unpause();
        } else e.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.deactivateTrap();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props.children ? Qe.Children.only(this.props.children) : void 0;
        if (t) {
          if (t.type && t.type === Qe.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
          return Qe.cloneElement(t, {
            ref: function ref(n) {
              var r = e.props.containerElements;
              t && ("function" == typeof t.ref ? t.ref(n) : t.ref && (t.ref.current = n)), e.focusTrapElements = r || [n];
            }
          });
        }
        return null;
      }
    }]) && ze(t.prototype, n), r && ze(t, r), Object.defineProperty(t, "prototype", {
      writable: !1
    }), a;
  }(),
  rt = "undefined" == typeof Element ? Function : Element;
nt.propTypes = {
  active: Ze.bool,
  paused: Ze.bool,
  focusTrapOptions: Ze.shape({
    document: Ze.object,
    onActivate: Ze.func,
    onPostActivate: Ze.func,
    checkCanFocusTrap: Ze.func,
    onPause: Ze.func,
    onPostPause: Ze.func,
    onUnpause: Ze.func,
    onPostUnpause: Ze.func,
    onDeactivate: Ze.func,
    onPostDeactivate: Ze.func,
    checkCanReturnFocus: Ze.func,
    initialFocus: Ze.oneOfType([Ze.instanceOf(rt), Ze.string, Ze.bool, Ze.func]),
    fallbackFocus: Ze.oneOfType([Ze.instanceOf(rt), Ze.string, Ze.func]),
    escapeDeactivates: Ze.oneOfType([Ze.bool, Ze.func]),
    clickOutsideDeactivates: Ze.oneOfType([Ze.bool, Ze.func]),
    returnFocusOnDeactivate: Ze.bool,
    setReturnFocus: Ze.oneOfType([Ze.instanceOf(rt), Ze.string, Ze.bool, Ze.func]),
    allowOutsideClick: Ze.oneOfType([Ze.bool, Ze.func]),
    preventScroll: Ze.bool,
    tabbableOptions: Ze.shape({
      displayCheck: Ze.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
      getShadowRoot: Ze.oneOfType([Ze.bool, Ze.func])
    }),
    trapStack: Ze.array,
    isKeyForward: Ze.func,
    isKeyBackward: Ze.func
  }),
  containerElements: Ze.arrayOf(Ze.instanceOf(rt)),
  children: Ze.oneOfType([Ze.element, Ze.instanceOf(rt)])
}, nt.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: et
};
var ot = nt;
var at = c(function (_ref, d) {
  var i = _ref.className,
    c = _ref.alertMessage,
    s = _ref.action,
    l = _ref.icon,
    f = _ref.showAlert,
    p = _ref.mode;
  var v = p ? "cds-alert--".concat(p, "-mode") : "";
  return f ? u.createPortal(e(t, {
    children: [n("div", Object.assign({
      ref: d,
      className: a("cds-alert", i, v)
    }, {
      children: n(ot, Object.assign({
        focusTrapOptions: {
          fallbackFocus: ".cds-alert__wrapper"
        }
      }, {
        children: e("div", Object.assign({
          className: "cds-alert__wrapper"
        }, {
          children: [l ? n(r, {
            icon: l
          }) : null, c ? n(o, {
            className: "cds-alert__content",
            variant: "body",
            content: c
          }) : null, n("div", Object.assign({
            className: "cds-alert__actions"
          }, {
            children: s
          }))]
        }))
      }))
    })), n("div", {
      className: a("cds-alert__overlay", {
        "cds-alert--inverse-mode": "inverse" === p
      })
    })]
  }), document.body) : null;
});
export { at as Alert };